import { PurchaseRequestLogModel }       from '../reports/models/purchase-request.log';
import { VehicleRegistrationServiceAjs } from './vehicle-registration.service.ajs';

interface VehicleRegistrationLookupsScope extends ng.IScope {
  getLookupsPage: any;
  lookups       : Array<PurchaseRequestLogModel>;
  tableSettings : any;
};

export function VehicleRegistrationLookupsCtrl (
  $scope                : VehicleRegistrationLookupsScope,
  $translate            : ng.translate.ITranslateService,
  vehicleRegistrationApi: VehicleRegistrationServiceAjs
) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'username',
        header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        field : 'request_note',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.LOOKUP')
        }
      },
      {
        field : 'request_time',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe    : 'globalDate',
        pipeArgs: 'MMM d, yyyy h:mm a'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND', {
        type: $translate.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.REGISTRATION_LOOKUPS')
      })
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => vehicleRegistrationApi.getLookupCount()
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getLookupsPage = ( params ) => {
    return vehicleRegistrationApi.getLookups(params)
    .then(lookups => {
      $scope.lookups = lookups;

      return lookups;
    });
  };
};
